<div class="ir-modal th-modal">
  <div class="ir-modal--title">
    <div class="ir-line--right">
      <div class="ir-btn th-btn-modal" (click)="selfModal.close()"><i class="material-icons">close</i></div>
    </div>
    <div class="ir-line">
      <div class="ir-line-content">
        <span>{{ 'app.version.new-functionalities' | translate }}</span>
      </div>
    </div>
  </div>
  <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
    <div class="ir-stabilizer">
      <div class="ir-version-block">
        <div class="ir-version-navigation">
          <div class="ir-version-navigation--titles">
            <div
              class="ir-version-navigation--title"
              *ngFor="let block of appVersion.blocks; index as i"
              (click)="index = i"
              [ngClass]="{ active: index === i }"
            >
              {{ block.title }}
            </div>
          </div>
          <div>
            <button (click)="next()" class="ir-btn ir-btn--title th-btn-action">
              <span>{{ 'app.version.next' | translate }}</span>
            </button>
          </div>
        </div>
        <div *ngIf="appVersion?.blocks" class="ir-version-content">
          <div class="ir-version-image">
            <img
              *ngIf="appVersion.blocks[index]?.image"
              style="width: 100%; height: 100%; object-fit: contain"
              [src]="appVersion.blocks[index].image"
            />
            <video
              *ngIf="appVersion.blocks[index]?.video"
              style="width: 100%; height: 100%; object-fit: contain"
              controls
              [src]="appVersion.blocks[index].video"
            ></video>
          </div>
          <div class="ir-version-text">
            <div class="ir-version-text--title">{{ appVersion.blocks[index]?.title }}</div>
            <div class="ir-version-text--description">{{ appVersion.blocks[index]?.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ir-modal--footer ir-position--b th-modal--footer">
    <div class="ir-row">
      <div class="ir-cell-tin12 ir-cell-sma12 ir-cell-mid12 ir-cell-lar12">
        <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--right" (click)="selfModal.close()">
          <span>{{ 'common.close' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
